export default __webpack_public_path__ + "static/media/x33-coin.6e37358c.svg";